/* eslint-disable ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/require-tagless-components */
import Component from '@ember/component';
import { action, computed } from '@ember/object';
import moment from 'moment';
import { classNames } from '@ember-decorators/component';

@classNames('layout-row layout-align-center-center')
export default class SessionManager extends Component {
  date = '';
  event = null;
  onDelete = null;
  onlyOneSession = false;
  session = null;

  @computed('session.{startTime,endTime}', 'event.{slotLength,slotFootprint}')
  get slotCount() {
    let startTime = moment
      .unix(this.session.startTime)
      .add(this.event.get('slotLength'), 'minutes');
    let endTime = moment.unix(this.session.endTime);
    return (
      Math.max(
        0,
        Math.floor(
          endTime.diff(startTime, 'minutes') / this.event.get('slotFootprint'),
        ),
      ) + 1
    );
  }

  @action
  setTime(timeType, time) {
    this.session.set(
      timeType,
      moment(`${this.date} ${time}`, 'YYYY-MM-DD HH:mm').unix(),
    );
  }
}
